module.exports = __webpack_public_path__ + "static/img/2813_phase_function_Paper_Points.2550d37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2813_phase_function_Paper_Points.png
// module id = 4Kn9
// module chunks = 0